"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMUNITY_PROFILE_DELETE_AVATAR = exports.COMMUNITY_PROFILE_UPLOAD_AVATAR = exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR = exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS = exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING = exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR = exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS = exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING = exports.COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES = exports.SET_COMMUNITY_PROFILE_PICTURES_ERROR = exports.SET_COMMUNITY_PROFILE_PICTURES_PROCESSING = exports.SET_COMMUNITY_PROFILE_PICTURES = void 0;
exports.uploadAvatar = uploadAvatar;
exports.deleteAvatar = deleteAvatar;
exports.fetchProfilePictures = fetchProfilePictures;
exports.setAvatarUploadProcessing = setAvatarUploadProcessing;
exports.setAvatarUploadSuccess = setAvatarUploadSuccess;
exports.setAvatarUploadError = setAvatarUploadError;
exports.setAvatarDeleteProcessing = setAvatarDeleteProcessing;
exports.setAvatarDeleteSuccess = setAvatarDeleteSuccess;
exports.setAvatarDeleteError = setAvatarDeleteError;
exports.setProfilePictures = setProfilePictures;
exports.setProfilePicturesProcessing = setProfilePicturesProcessing;
exports.setProfilePicturesError = setProfilePicturesError;
// Profile pictures state
exports.SET_COMMUNITY_PROFILE_PICTURES = 'SET_COMMUNITY_PROFILE_PICTURES';
exports.SET_COMMUNITY_PROFILE_PICTURES_PROCESSING = 'SET_COMMUNITY_PROFILE_PICTURES_PROCESSING';
exports.SET_COMMUNITY_PROFILE_PICTURES_ERROR = 'SET_COMMUNITY_PROFILE_PICTURES_ERROR';
// Profile pictures watcher trigger
exports.COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES = 'COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES';
// Avatar upload state
exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING';
exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS';
exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR';
// Avatar delete state
exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING';
exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS';
exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR';
// Avatar watcher triggers
exports.COMMUNITY_PROFILE_UPLOAD_AVATAR = 'COMMUNITY_PROFILE_UPLOAD_AVATAR';
exports.COMMUNITY_PROFILE_DELETE_AVATAR = 'COMMUNITY_PROFILE_DELETE_AVATAR';
// ── Watcher-trigger action creators ──────────────────────────────────
function uploadAvatar(_a) {
    var imageBlob = _a.imageBlob, fileExtension = _a.fileExtension;
    return {
        type: exports.COMMUNITY_PROFILE_UPLOAD_AVATAR,
        payload: { imageBlob: imageBlob, fileExtension: fileExtension },
    };
}
function deleteAvatar() {
    return {
        type: exports.COMMUNITY_PROFILE_DELETE_AVATAR,
    };
}
function fetchProfilePictures(uids) {
    return {
        type: exports.COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES,
        payload: { uids: uids },
    };
}
// ── SET_* action creators (used by watchers) ─────────────────────────
function setAvatarUploadProcessing(processing) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING,
        payload: processing,
    };
}
function setAvatarUploadSuccess() {
    return {
        type: exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS,
    };
}
function setAvatarUploadError(error) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR,
        payload: error,
    };
}
function setAvatarDeleteProcessing(processing) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING,
        payload: processing,
    };
}
function setAvatarDeleteSuccess() {
    return {
        type: exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS,
    };
}
function setAvatarDeleteError(error) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR,
        payload: error,
    };
}
function setProfilePictures(payload) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_PICTURES,
        payload: payload,
    };
}
function setProfilePicturesProcessing(processing) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_PICTURES_PROCESSING,
        payload: processing,
    };
}
function setProfilePicturesError(error) {
    return {
        type: exports.SET_COMMUNITY_PROFILE_PICTURES_ERROR,
        payload: error,
    };
}
